import { HubConnection } from "@microsoft/signalr";
import React from "react";

type UseWatchConnectionArgs = {
  connection: HubConnection;
  onReconnect: () => void;
  onConnectionClose: (err?: Error | undefined) => void;
};

export function useWatchConnectionState({
  connection,
  onConnectionClose,
  onReconnect,
}: UseWatchConnectionArgs): void {
  React.useEffect(() => {
    connection.onclose(onConnectionClose);
    connection.onreconnected(onReconnect);
  }, [connection, onConnectionClose, onReconnect]);
}
